/* ── component ── */

export default function DrawdownEnvelopeMock() {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        margin: '0 auto',
        borderRadius: 12,
        overflow: 'hidden',
        fontFamily:
          'Inter, ui-sans-serif, system-ui, -apple-system, sans-serif',
      }}
    >
      {/* header */}
      <div
        style={{
          background: '#111827',
          padding: '18px 24px 0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <div>
          <h3
            style={{
              color: '#f9fafb',
              fontSize: 14,
              fontWeight: 700,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              margin: 0,
            }}
          >
            Drawdown Envelope (Monte Carlo)
          </h3>
          <p
            style={{ color: '#9ca3af', fontSize: 12, margin: '6px 0 16px' }}
          >
            Drawdown dispersion under 10,000 randomized trade orderings
          </p>
        </div>
        <span
          style={{
            fontSize: 10,
            color: '#6b7280',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            marginTop: 2,
          }}
        >
          &#x21BB; Re-run
        </span>
      </div>

      {/* 2x2 grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 12,
          padding: '12px 24px',
          background: '#111827',
        }}
      >
        {/* top-left: Observed vs Typical */}
        <Card>
          <SectionLabel>Observed vs Typical</SectionLabel>
          <div style={{ marginTop: 10 }}>
            <MetricRow label="Your Max DD" value="26.4%" valueColor="#f43f5e" />
            <MetricRow label="Typical (Median)" value="21.6%" />
            <div
              style={{
                borderTop: '1px solid #374151',
                marginTop: 8,
                paddingTop: 8,
              }}
            >
              <MetricRow
                label="Difference"
                value="+4.8% above typical"
                valueColor="#f43f5e"
              />
            </div>
          </div>
        </Card>

        {/* top-right: Expected Range */}
        <Card>
          <SectionLabel>Expected Range</SectionLabel>
          <div style={{ marginTop: 10 }}>
            <MetricRow
              label="Best case (5th)"
              value="10.1%"
              valueColor="#34d399"
            />
            <MetricRow
              label="Worst case (95th)"
              value="49.4%"
              valueColor="#f43f5e"
            />
            <div
              style={{
                borderTop: '1px solid #374151',
                marginTop: 8,
                paddingTop: 8,
              }}
            >
              <MetricRow label="Range width" value="39.3 pts" />
            </div>
          </div>
          <p
            style={{
              fontSize: 10,
              color: '#6b7280',
              fontStyle: 'italic',
              margin: '8px 0 0',
            }}
          >
            Most random orderings fall within this range
          </p>
        </Card>

        {/* bottom-left: Drawdown Distribution */}
        <Card>
          <SectionLabel>Drawdown Distribution</SectionLabel>
          <div style={{ marginTop: 12 }}>
            {/* distribution bar */}
            <div
              style={{
                position: 'relative',
                height: 32,
                background: '#4b5563',
                borderRadius: 4,
                overflow: 'hidden',
              }}
            >
              {/* P5-P95 band — spans the middle portion */}
              <div
                style={{
                  position: 'absolute',
                  left: '0%',
                  width: '100%',
                  top: 0,
                  bottom: 0,
                  display: 'flex',
                }}
              >
                {/* green-ish left zone (best case region) */}
                <div
                  style={{
                    width: '14%',
                    background: '#4b7a5e',
                    opacity: 0.7,
                  }}
                />
                {/* orange mid-left */}
                <div
                  style={{
                    width: '18%',
                    background: '#b45309',
                    opacity: 0.6,
                  }}
                />
                {/* orange-red mid */}
                <div
                  style={{
                    width: '8%',
                    background: '#c2410c',
                    opacity: 0.5,
                  }}
                />
                {/* muted right zone (worst case region) */}
                <div
                  style={{
                    width: '60%',
                    background: '#6b7280',
                    opacity: 0.4,
                  }}
                />
              </div>

              {/* Median line */}
              <div
                style={{
                  position: 'absolute',
                  left: '30%',
                  top: 0,
                  bottom: 0,
                  width: 2,
                  background: '#fb923c',
                  zIndex: 2,
                }}
              />

              {/* Your marker */}
              <div
                style={{
                  position: 'absolute',
                  left: '41%',
                  top: 0,
                  bottom: 0,
                  width: 6,
                  background: '#d1d5db',
                  borderRadius: 2,
                  zIndex: 3,
                }}
              />
            </div>

            {/* axis + legend */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: 6,
                fontSize: 9,
                color: '#9ca3af',
              }}
            >
              <span>10%</span>
              <div style={{ display: 'flex', gap: 12 }}>
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 3,
                  }}
                >
                  <span
                    style={{
                      width: 6,
                      height: 6,
                      background: '#d1d5db',
                      borderRadius: '50%',
                      display: 'inline-block',
                    }}
                  />
                  You
                </span>
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 3,
                  }}
                >
                  <span
                    style={{
                      width: 8,
                      height: 2,
                      background: '#fb923c',
                      display: 'inline-block',
                    }}
                  />
                  Median
                </span>
              </div>
              <span>49%</span>
            </div>
          </div>
        </Card>

        {/* bottom-right: Sequencing Assessment */}
        <Card>
          <SectionLabel>Sequencing Assessment</SectionLabel>
          <div style={{ marginTop: 10 }}>
            <MetricRow label="Percentile" value="66th" />
            <p
              style={{
                fontSize: 10,
                color: '#6b7280',
                margin: '2px 0 12px',
              }}
            >
              Slightly worse than typical, not extreme
            </p>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
              }}
            >
              <span style={{ fontSize: 11, color: '#9ca3af' }}>
                Sensitivity
              </span>
              <span
                style={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: '#fbbf24',
                }}
              >
                Moderate
              </span>
            </div>

            {/* sensitivity scale */}
            <div
              style={{
                display: 'flex',
                gap: 6,
                fontSize: 10,
                color: '#6b7280',
                margin: '6px 0 14px',
              }}
            >
              <span>Low</span>
              <span>&middot;</span>
              <span style={{ color: '#fbbf24', fontWeight: 600 }}>
                Moderate
              </span>
              <span>&middot;</span>
              <span>High</span>
            </div>

            <p
              style={{
                fontSize: 10,
                color: '#9ca3af',
                borderTop: '1px solid #374151',
                paddingTop: 8,
                margin: 0,
                lineHeight: 1.5,
              }}
            >
              Observed drawdown is slightly above typical but within expected
              range
            </p>
          </div>
        </Card>
      </div>

      {/* full-width interpretation */}
      <div style={{ padding: '0 24px 12px', background: '#111827' }}>
        <div
          style={{
            background: '#1f2937',
            borderRadius: 8,
            padding: 16,
            border: '1px solid #374151',
          }}
        >
          <h4
            style={{
              color: '#f9fafb',
              fontSize: 13,
              fontWeight: 700,
              margin: '0 0 14px',
            }}
          >
            Observed Sequencing Interpretation
          </h4>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 24,
            }}
          >
            <div>
              <SectionLabel>Characteristics</SectionLabel>
              <ul
                style={{
                  margin: '8px 0 0',
                  padding: '0 0 0 16px',
                  fontSize: 11,
                  color: '#9ca3af',
                  lineHeight: 1.8,
                }}
              >
                <li>Drawdown falls within normal simulated range</li>
                <li>Not driven by extreme trade ordering</li>
                <li>Outcome reflects strategy structure rather than ordering</li>
              </ul>
            </div>
            <div>
              <SectionLabel>Implications</SectionLabel>
              <ul
                style={{
                  margin: '8px 0 0',
                  padding: '0 0 0 16px',
                  fontSize: 11,
                  color: '#9ca3af',
                  lineHeight: 1.8,
                }}
              >
                <li>
                  Outcome influenced by sequencing, but within normal variation
                </li>
                <li>Future drawdowns may vary within expected bounds</li>
                <li>No evidence of hidden tail risk from sequencing</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* collapsible footer hint */}
      <div style={{ background: '#111827', padding: '0 24px 18px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 11,
            color: '#6b7280',
            cursor: 'pointer',
          }}
        >
          <span style={{ fontSize: 10 }}>&#9662;</span>
          Additional Statistics
        </div>
      </div>
    </div>
  );
}

/* ── helper components ── */

function Card({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        background: '#1f2937',
        borderRadius: 8,
        padding: 14,
        border: '1px solid #374151',
      }}
    >
      {children}
    </div>
  );
}

function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <p
      style={{
        fontSize: 10,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#9ca3af',
        margin: 0,
      }}
    >
      {children}
    </p>
  );
}

function MetricRow({
  label,
  value,
  valueColor,
}: {
  label: string;
  value: string;
  valueColor?: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        fontSize: 11,
        marginBottom: 4,
      }}
    >
      <span style={{ color: '#9ca3af' }}>{label}</span>
      <span
        style={{
          color: valueColor || '#f9fafb',
          fontWeight: 600,
          fontSize: valueColor ? 14 : 11,
        }}
      >
        {value}
      </span>
    </div>
  );
}
